export enum AdminAddPharmacyFormItemLabel {
  Name = "Ime",
  Adress = "Adresa",
  PhoneNumber = "Broj telefona",
  Email = "Email adresa",
}
